import React, { useState } from 'react';
import { TrendUp } from '@phosphor-icons/react';

// PRO75 Smart Saver benefit panel. Shows the total $ saving up front; the
// per-tub examples are opt-in via toggles — margin is expressed as a %, profit
// as $. `example` comes from computePro75MarginExample; `context` switches the
// wording between 'saver', 'order' and 'planner'.
export const Pro75MarginExample = ({ example, context = 'saver' }) => {
  const [showMargin, setShowMargin] = useState(false);
  const [showProfit, setShowProfit] = useState(false);
  if (!example) return null;
  const { tubCount, totalSaving, perTubBoost, sizes } = example;
  const scopeWord = context === 'saver' ? 'saver' : 'order';
  const toggleClass = (active) =>
    `px-2.5 py-1 rounded-full text-[11px] font-semibold border transition-colors ${
      active
        ? 'bg-success text-black border-success'
        : 'bg-transparent text-success border-success/40 hover:border-success'
    }`;
  return (
    <div
      data-testid={`pro75-margin-example-${context}`}
      className="mt-3 px-4 py-3 rounded-lg bg-success/10 border border-success/30"
    >
      <p className="flex items-center gap-1.5 text-xs font-semibold text-success" data-testid={`pro75-benefit-total-${context}`}>
        <TrendUp size={15} weight="bold" />
        PRO75 Smart Saver benefit — ${totalSaving.toFixed(2)} total saving.
      </p>
      <p className="text-xs text-text-secondary mt-1 leading-snug">
        See what that saving could do spread across the {tubCount} PRO75 tub{tubCount === 1 ? '' : 's'} in
        this {scopeWord}:
      </p>
      <div className="flex flex-wrap gap-2 mt-2">
        <button
          type="button"
          onClick={() => setShowMargin((v) => !v)}
          data-testid={`pro75-benefit-toggle-margin-${context}`}
          className={toggleClass(showMargin)}
        >
          Margin per tub (%)
        </button>
        <button
          type="button"
          onClick={() => setShowProfit((v) => !v)}
          data-testid={`pro75-benefit-toggle-profit-${context}`}
          className={toggleClass(showProfit)}
        >
          Profit per tub ($)
        </button>
      </div>
      {showMargin && (
        <div className="mt-2 space-y-0.5" data-testid={`pro75-margin-section-${context}`}>
          {sizes.map((s) => (
            <p key={`m-${s.size}`} className="text-xs text-text-secondary" data-testid={`pro75-margin-line-${s.size}-${context}`}>
              {s.size} PRO75 tub: margin ~{s.baseMarginPct.toFixed(1)}% →{' '}
              <span className="text-success font-semibold">~{s.boostedMarginPct.toFixed(1)}%</span>
            </p>
          ))}
        </div>
      )}
      {showProfit && (
        <div className="mt-2 space-y-0.5" data-testid={`pro75-profit-section-${context}`}>
          {sizes.map((s) => (
            <p key={`p-${s.size}`} className="text-xs text-text-secondary" data-testid={`pro75-profit-line-${s.size}-${context}`}>
              {s.size} PRO75 tub: profit ~${s.baseMargin.toFixed(2)} →{' '}
              <span className="text-success font-semibold">~${s.boostedMargin.toFixed(2)}</span>
              {' '}(+${perTubBoost.toFixed(2)}/tub, ex-GST)
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default Pro75MarginExample;
